import React, { useEffect, useRef } from 'react';
import './BookPage.css';
import { PagePreset } from './pagePresets';

export interface BookPageProps {
  /** Question text */
  question: string;
  /** Answer text (controlled) */
  answer: string;
  /** Answer change handler */
  onChange: (value: string) => void;
  /** Verstka preset */
  preset: PagePreset;
  /** Footer title (shown on the left) */
  footerTitle?: string;
  /** Page number (footer right) */
  pageNumber?: number;
  /** Placeholder for empty answer */
  placeholder?: string;
  /** Hide the question block */
  showQuestion?: boolean;
  /** Make answer non-editable */
  readOnly?: boolean;
  /** Autofocus textarea on mount */
  autoFocus?: boolean;
  /** Wrapper className */
  className?: string;
}

export const BookPage: React.FC<BookPageProps> = ({
  question,
  answer,
  onChange,
  preset,
  footerTitle,
  pageNumber,
  placeholder = 'начните писать…',
  showQuestion = true,
  readOnly = false,
  autoFocus = false,
  className = '',
}) => {
  const taRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (autoFocus && taRef.current) {
      taRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className={`bp bp--${preset} ${className}`}>
      <div className="bp__sheet">
        <div className="bp__body">
          {showQuestion && question && (
            <div className="bp__question">{question}</div>
          )}

          <textarea
            ref={taRef}
            className="bp__answer"
            value={answer}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            readOnly={readOnly}
          />
        </div>

        <div className="bp__footer">
          <span className="bp__footer-title">{footerTitle ?? '\u00A0'}</span>
          <span className="bp__folio">
            {pageNumber !== undefined ? pageNumber : '\u00A0'}
          </span>
        </div>
      </div>
    </div>
  );
};
